import { Property, PropertyDocument, PropertyDocumentResponse  } from "../../types/property-types";
import { NativeDataFetcher } from "@sitecore-jss/sitecore-jss";

export const getProperties = async (): Promise<PropertyDocumentResponse | null> => {
  const fetchOptions = {
    headers: {
      [process.env.ApimHeader ?? "ApimHeader"]: process.env.ApimKey ?? "ApimKey",
    },
  };

  let allProperties: PropertyDocument[]=[];
  let continuationToken: string | undefined = undefined;
  const seenTokens = new Set<string | undefined>();

  try {
    do {
      if (continuationToken && seenTokens.has(continuationToken)) {
        // Detected a repeated token, break to prevent infinite loop
        break;
      }
      seenTokens.add(continuationToken);
      const url: string = continuationToken
        ? `${process.env.ApimHost}/property/list?continuation=${continuationToken}`
        : `${process.env.ApimHost}/property/list`;

      const response = await fetch(url, fetchOptions);
      const data = (await response.json()) as PropertyDocumentResponse;
      const headersObj = Object.fromEntries(response.headers.entries());
      continuationToken = headersObj["api-continuation"] ?? undefined;

      if (data?.Documents) {
        const mappedProperties: PropertyDocument[] = propertyDocuments(data.Documents);
        // Only add properties with unique ids
        mappedProperties.forEach((property) => {
          if (!allProperties.some((p) => p.id === property.id)) {
            allProperties.push(property);
          }
        });
      } else {
        continuationToken = undefined;
      }
    } while (continuationToken);

    return {
      Documents: allProperties
    };
  } catch (e) {
    return null;
  }
};

export const propertyDocuments = (documents: PropertyDocument[]): PropertyDocument[] => {
  return documents.map((property: PropertyDocument) => ({
    ...property,
  }));
};

export const getProperty = async (propertyId: string): Promise<Property | null> => {
  const fetcher = new NativeDataFetcher({
    headers: [[process.env.ApimHeader ?? "ApimHeader", process.env.ApimKey ?? "ApimKey"]],
  });

  return await fetcher
    .get<Property>(`${process.env.ApimHost}/property/${propertyId}`)
    .then((response) => {
      if (response.data.id) {
        return response.data;
      }
      return null;
    })
      .catch((e) => {
      console.log(e);
      return null;
    });
};